// API 配置
//export const API_BASE_URL = 'http://dev.dengyun.me'
export const API_BASE_URL = 'https://dengyun.me'


// 文件上传配置
//export const UPLOAD_API_URL = 'http://dev.dengyun.me'
//export const STATIC_FILE_URL = 'http://dev.dengyun.me/upload'
export const UPLOAD_API_URL = 'https://dengyun.me'
export const STATIC_FILE_URL = 'https://dengyun.me/upload'

// 其他配置
export const APP_NAME = '创业笔记'
export const VERSION = '1.0.0'
export const AUTHOR = 'dengyun'
